import { Cart, CartConstantsEnum, cartApi, updateCart, updateIsLoading } from '@commerce-cart-webcomponents/sdk';
import { StorageService } from '@nextgen-web-framework/core';
import { useDispatch } from 'react-redux';
import { Checkbox } from '@nextgen-web-framework/all';
import { CartAllSelectionCheckboxProps } from './types/propsType';

export const CartAllSelectionCheckbox = ({ cartData, text = '' }: CartAllSelectionCheckboxProps) => {
  const dispatch = useDispatch();
  const checkAllCheckbox = (data: Cart) => {
    let checked = true;
    data.subCarts.forEach(({ selected, totalEntries }) => {
      // checkbox should be selected when cart is disabled due to empty entries
      if ((!selected && totalEntries !== 0) || data?.totalEntries === 0) {
        checked = false;
      }
    });
    return checked;
  };

  const checkAllSubCart = (cart: Cart, prevState: boolean) => {
    const cartReqVersion = StorageService.getLocalStorage().retrieve(CartConstantsEnum.CartReqVersion);
    return cartApi.updateCart(cart.id, cart.id, {
      selectedAll: !prevState,
      version: +cartReqVersion,
    });
  };
  const handleCheckboxChange = async () => {
    try {
      dispatch(updateIsLoading(true));
      const res = (await checkAllSubCart(cartData, checkAllCheckbox(cartData))) as Cart;
      dispatch(updateCart(res));
    } finally {
      dispatch(updateIsLoading(false));
    }
  };
  return <Checkbox checked={checkAllCheckbox(cartData)} onClick={handleCheckboxChange} text={text} />;
};
